import { SessionStore } from '@/stores/session/store';
import { createContext } from 'react';

export const SessionContext = createContext<SessionStore | null>(null);
